// extracted by mini-css-extract-plugin
export default {"toplistContainer":"toplist-module__toplistContainer__EZRRc"};